import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import { MainWrapper, AnchorLinkStyled } from "components"
import {
  HeaderWrapper,
  MainContent,
  TextAndContent,
  MenuContent,
  BackImage,
  Gradient,
} from "./styles"

export const Header = () => {
  return (
    <HeaderWrapper>
      <BackImage>
        <StaticImage
          src="../../images/b3.jpg"
          alt="Barragans Restaurant"
          quality="90"
          placeholder="blurred"
          imgStyle={{ position: "fixed" }}
          imgClassName="img-fixed"
        />
        <Gradient />
      </BackImage>
      <MainWrapper>
        <MainContent>
          <TextAndContent>
            <StaticImage
              src="../../images/logo.png"
              alt="Barragans Restaurant"
              quality="100"
              placeholder="blurred"
            />
            {/* <img
              data-sal="slide-up"
              data-sal-delay="250"
              data-sal-easing="ease"
              src={logo}
              alt="Barragans Restaurant"
            /> */}
            <h3 data-sal="slide-up" data-sal-delay="300" data-sal-easing="ease">
              MEXICAN RESTAURANT
            </h3>

            <span
              data-sal="slide-up"
              data-sal-delay="350"
              data-sal-easing="ease"
            >
              Since 1961
            </span>
            {/* <ButtonContent>
              <SimpleButton
                background="linear-gradient(90deg,#da3654 0,#eb5295)"
                color="white"
                padding="7px 30px"
                margin="0"
              >
                Order Online
              </SimpleButton>
            </ButtonContent> */}
            <MenuContent
              data-sal="slide-up"
              data-sal-delay="400"
              data-sal-easing="ease"
            >
              <AnchorLinkStyled
                fontFamily="'Oswald', sans-serif"
                to="/#special-menu"
              >
                Special Menu
              </AnchorLinkStyled>{" "}
              |
              <AnchorLinkStyled
                fontFamily="'Oswald', sans-serif"
                to="/#gallery"
              >
                Gallery
              </AnchorLinkStyled>{" "}
              |
              <AnchorLinkStyled
                fontFamily="'Oswald', sans-serif"
                to="/#contact"
              >
                Contact
              </AnchorLinkStyled>
            </MenuContent>
          </TextAndContent>
        </MainContent>
      </MainWrapper>
    </HeaderWrapper>
  )
}
